export const HIDE_SCROLL_TOP_MS = 4000;
export const CAREERS_SLIDER_SWITCH_TIME = 5000;
export const SUBMIT_EMAIL_MESSAGE_MS = 4000;
export const SCROLL_TRIGGER_POINT = 480;
export const WEBSITE_NAME = "Aster Information";
export const SCREEN_SIZES = {
  desktop: 1200,
  laptop: 992,
  tablet: 768,
  mobile: 428,
  smaller: 376,
};
export const regexPatterns = {
  email: /^[0-9a-zA-Z._]+@[a-z]+\.[a-z]+$/,
};
